import { useMutation } from "@tanstack/react-query";
import { rmModifyApi, rmsApi } from "components/api/rm";
import { apifield } from "components/utils/comm";
import {
  getFormData,
  initialPageNav,
  pageInitInf,
} from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IRm } from "interface/rm/rm";
import i18n from "locales/i18n";
import { FormEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import useListRowInfStroe from "store/listRowInf";
import useLodStore from "store/lod";
import { useRoomListContext } from "../context";
import usePageNoStore from "store/pageNo";
import { PAGE_ID_ROOM_ROOM } from "components/constent";
import useModalStore from "store/modal";

// 객실 리스트 조회
export const useSearchList = () => {
  const { t } = useTranslation();
  const lod = useLodStore((state) => state.lod);
  const { isSuccess, setIsSuccess, param } = useRoomListContext();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const mutation = useMutation({
    mutationKey: ["room-search"],
    mutationFn: rmsApi,
    onSuccess: (res) => {
      const {
        status: { code, message },
        data,
      } = res;
      if (code === 0) {
        const pageNav = res.data.pageNav;
        const rms = res.data.rmList.map((rm: IRm, index: number) => {
          return {
            ...rm,
            No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
            uYn: rm.uyn === "Y" ? t("uyn_y") : t("uyn_n"),
            regiSt: rm.rmNm ? t("status_complete") : t("status_process"),
          };
        });
        pageNavRef.current = pageNav;
        setRowData(rms);
        setIsSuccess(false);
      }
      if (code === -1) {
        apifield(message);
      }
    },
  });

  useEffect(() => {
    if (param) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
        langCd: i18n.language,
        lodNo: lod?.lodNo ?? "",
      });
    }
  }, [param]);

  useEffect(() => {
    if (isSuccess) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
        langCd: i18n.language,
        lodNo: lod?.lodNo ?? "",
      });
    }
  }, [isSuccess]);

  // NextPage
  const pageNo = usePageNoStore((state) => state.pageNo);
  const isCurrent = pageNo?.target === PAGE_ID_ROOM_ROOM;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNavRef: pageNavRef,
  };
};

// 객실 상테변경
export const useUpdateStatusMutate = () => {
  const onsetAlert = useAlertStore((state) => state.onSetAlert);
  const handleModal = useModalStore((state) => state.handleModal);
  const { setIsSuccess } = useRoomListContext();
  return useMutation({
    mutationKey: ["room-update-status"],
    mutationFn: rmModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 상태변경 완료 시 리스트 새롭게 가져오기
          onsetAlert({
            isOpen: true,
            inner: "상태변경을 완료하였습니다.",
            onSetConfirm: () => {
              setIsSuccess(true);
              handleModal(false);
            },
          });
        }
      }
    },
  });
};

export const useUpdateStatus = () => {
  const { mutate } = useUpdateStatusMutate();

  const updateStatus = () => {
    const { listRowInf } = useListRowInfStroe.getState();
    const { lod } = useLodStore.getState();
    const parmas = {
      rmNo: listRowInf.no,
      lodNo: lod?.lodNo,
      uyn: listRowInf.btnNm.split("_")[1],
      langCd: i18n.language,
    };

    mutate(parmas);
  };

  return {
    updateStatus,
  };
};
